import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 27V5a1 1 0 1 1 2 0v22a1 1 0 1 1-2 0M3 9v14a2 2 0 0 0 2 2h7a1 1 0 1 0 0-2H5V9h7a1 1 0 1 0 0-2H5a2 2 0 0 0-2 2M29 9v14a2 2 0 0 1-2 2h-7a1 1 0 1 1 0-2h7V9h-7a1 1 0 1 1 0-2h7a2 2 0 0 1 2 2"
    />
  </svg>
);
const SvgIconSplitView = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSplitView);
export default Memo;
